export const ACTION_TOGGLE_DISPLAY_INFO = 'ACTION_TOGGLE_DISPLAY_INFO'
export const ACTION_TOGGLE_DISPLAY_FILTERS = 'ACTION_TOGGLE_DISPLAY_FILTERS'
